module.exports = __webpack_public_path__ + "img/senderrand-business-step-3.ebd8af46.svg";